<template>
  <v-app class="pay">
    <v-container
      fluid
      fill-height
      class="d-flex flex-column align-center justify-center text-center"
    >
      <transition name="fade-scale">
        <div v-if="appLoading" class="content-wrapper">
          <v-progress-circular
            indeterminate
            color="#F86031"
            size="64"
            width="6"
            class="loader-pulse"
          ></v-progress-circular>

          <div class="text-wrapper mt-6">
            <h2 class="title-text">Please don't go back or refresh the page</h2>
            <p class="subtitle-text">while we redirect you securely</p>
          </div>

          <div class="dots mt-8"><span></span><span></span><span></span></div>
        </div>
      </transition>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';

export default {
  props: ['paymentId', 'orderid', 'productId'],
  data() {
    return {
      appLoading: true,
    };
  },
  created() {
    this.paymentStatus();
  },
  methods: {
    paymentStatus() {
      axios({
        method: 'POST',
        url: 'https://live.ohyesworld.com/membership-plan/razorpay/callback',
        data: {
          id: this.$route.query.razorpay_invoice_id,
        },
      })
        .then((response) => {
          const PaymentData = response.data.data;
          console.log('Full PaymentData:', PaymentData);
          if (PaymentData.payment_sucess === true) {
            console.log('Payment success:', PaymentData.payment_sucess);
            setTimeout(() => {
              location.href = 'https://homemaintenance.ohyesworld.com/Success';
            }, 3000);
          } else {
            console.log('Payment failed:', PaymentData.payment_sucess);
            setTimeout(() => {
              location.href = 'https://homemaintenance.ohyesworld.com/Failure';
            }, 3000);
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          setTimeout(() => {
            location.href = 'https://homemaintenance.ohyesworld.com/Failure';
          }, 3000);
        });
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700;900&display=swap');

.pay {
  font-family: 'Nunito Sans', sans-serif;
  background-color: #ffffff;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
}

.content-wrapper {
  animation: fadeIn 0.8s ease-in-out;
}

.title-text {
  font-size: 22px;
  font-weight: 900;
  color: #000;
  letter-spacing: 0.5px;
  margin-bottom: 6px;
}

.subtitle-text {
  font-size: 16px;
  color: #666;
}

.loader-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

.dots {
  display: flex;
  justify-content: center;
  gap: 8px;
}

.dots span {
  width: 10px;
  height: 10px;
  background-color: #f86031;
  border-radius: 50%;
  display: inline-block;
  animation: bounce 1.4s infinite ease-in-out both;
}

.dots span:nth-child(1) {
  animation-delay: -0.32s;
}
.dots span:nth-child(2) {
  animation-delay: -0.16s;
}

/* Animations */
@keyframes fadeIn {
  0% {
    opacity: 0;
    transform: translateY(15px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 0.9;
  }
  50% {
    transform: scale(1.1);
    opacity: 1;
  }
  100% {
    transform: scale(1);
    opacity: 0.9;
  }
}

@keyframes bounce {
  0%,
  80%,
  100% {
    transform: scale(0);
  }
  40% {
    transform: scale(1);
  }
}

.fade-scale-enter-active {
  transition: all 0.6s ease;
}
.fade-scale-enter {
  opacity: 0;
  transform: scale(0.9);
}
</style>
